export type CanvasGridMode = "lines" | "dots" | "none";

export type CanvasCursorTool = "arrow" | "hand";

export const CANVAS_GRID_MODES: {
  key: CanvasGridMode;
  name: string;
}[] = [
  { key: "lines", name: "Line grid" },
  { key: "dots", name: "Dot grid" },
  { key: "none", name: "No grid" },
];

export const CANVAS_CURSOR_TOOLS: {
  key: CanvasCursorTool;
  name: string;
}[] = [
  { key: "arrow", name: "Arrow" },
  { key: "hand", name: "Pointer" },
];

export const CANVAS_CONTROLS_STORAGE_KEYS = {
  gridMode: "canvas.controls.gridMode",
  cursorTool: "canvas.controls.cursorTool",
} as const;

const GRID_MODE_KEYS = new Set<CanvasGridMode>(
  CANVAS_GRID_MODES.map((mode) => mode.key),
);

export function parseCanvasGridMode(
  stored: CanvasGridMode | undefined,
): CanvasGridMode {
  if (stored && GRID_MODE_KEYS.has(stored)) return stored;
  return "lines";
}

export function parseCanvasCursorTool(
  stored: string | undefined,
): CanvasCursorTool {
  if (stored === "arrow" || stored === "hand") return stored;
  // Legacy persisted keys (default → arrow, pointer → hand)
  if (stored === "default") return "arrow";
  if (stored === "pointer") return "hand";
  return "arrow";
}
